import { render, staticRenderFns } from "./vat-chart-admin.vue?vue&type=template&id=5ab7321b&"
import script from "./vat-chart-admin.vue?vue&type=script&lang=ts&"
export * from "./vat-chart-admin.vue?vue&type=script&lang=ts&"
import style0 from "./vat-chart-admin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports